import * as React from "react";
import { StyleClass } from "../Styles/CSS";

export function DisplayFetchingData() {
    const containerStyleClass = StyleClass(`fetchingDataContainer`, {
        margin: "0",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        textAlign: `center`,
        width: "90%",
    });

    return <div className={containerStyleClass}>Fetching data...</div>;
}
